// This is the root reducer of the feature. It is used for:
//   1. Load reducers from each action in the feature and process them one by one.
//      Note that this part of code is mainly maintained by Rekit, you usually don't need to edit them.
//   2. Write cross-topic reducers. If a reducer is not bound to some specific action.
//      Then it could be written here.
// Learn more from the introduction of this approach:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da.

import initialState from './initialState';
import { reducer as getCarLotsReducer } from './getCarLots';
import { reducer as getBranchOfficesReducer } from './getBranchOffices';
import { reducer as getRolesReducer } from './getRoles';
import { reducer as getBusinessUnitsReducer } from './getBusinessUnits';
import { reducer as createUserReducer } from './createUser';
import { reducer as getUsersReducer } from './getUsers';
import { reducer as getUserByIdReducer } from './getUserById';
import { reducer as getUserByConfirmIdReducer } from './getUserByConfirmId';
import { reducer as getToolsByRoleReducer } from './getToolsByRole';
import { reducer as updateUserReducer } from './updateUser';
import { reducer as deleteUserReducer } from './deleteUser';
import { reducer as sendUserConfirmationReducer } from './sendUserConfirmation';
import { reducer as confirmUserReducer } from './confirmUser';
import { reducer as updateUserPasswordReducer } from './updateUserPassword';
import { reducer as updatePhoneNumberReducer } from './updatePhoneNumber';
import { reducer as cleanErrorsReducer } from './cleanErrors';
import { reducer as updateUserProfilePictureReducer } from './updateUserProfilePicture';


const reducers = [
  getCarLotsReducer,
  getBranchOfficesReducer,
  getRolesReducer,
  getBusinessUnitsReducer,
  createUserReducer,
  getUsersReducer,
  getUserByIdReducer,
  getToolsByRoleReducer,
  updateUserReducer,
  deleteUserReducer,
  sendUserConfirmationReducer,
  confirmUserReducer,
  updateUserPasswordReducer,
  updatePhoneNumberReducer,
  cleanErrorsReducer,
  updateUserProfilePictureReducer,
  getUserByConfirmIdReducer,
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    // Handle cross-topic actions here
    default:
      newState = state;
      break;
  }
  return reducers.reduce((s, r) => r(s, action), newState);
}
